import { FormControl, ListItemIcon, MenuItem, Select, SelectChangeEvent } from '@mui/material';

import * as React from 'react';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { useContext } from 'react';
import { OrganisationContext } from '../App';
import { getAssetsBaseUrl } from '../utils/env';

export const RootText = styled(Box)`
    display: flex;
    gap: 1;
    min-height: 24px;
    font-family: 'ProximaNovaSemiBold';
    color: rgba(0, 0, 0, 0.87);
    align-items: center;

    > img {
        padding-right: 6px;
    }
`;

const PubAvatarRoot = styled(Box)`
    display: flex;
    align-items: center;
    height: 43px;
    border-style: solid;
    border-width: 1px;
    border-color: #e0e0e0;
    border-radius: 4px;
    padding-left: 8px;
    padding-right: 8px;
    flex: 0 0 220px;
    white-space: nowrap;
`;

const LogoRoot = styled('span')`
    padding-right: 6px;
    display: flex;
`;

export const PublicationSelector = () => {
  const {
    setSelectedOrganisation,
    organisations,
    selectedOrganisation
  } = useContext(OrganisationContext);
  const organisation = organisations.find(({ domain }) => domain === selectedOrganisation) || organisations[0];

  if (organisations.length === 0) return null;

  if (organisations.length === 1) {
    const [pub] = organisations;

    return (
      <PubAvatarRoot>
        <LogoRoot>
          {organisation?.logo_filename && <img width="24"
                                               src={`${getAssetsBaseUrl()}/logo/${organisation.logo_filename}`}
                                               alt={`${organisation?.name} logo`}/>}
          {!organisation?.logo_filename &&
            <img width="24" src={`https://assets.pixels.ai/logo/unknown-logo.png`}
                 alt={`${organisation?.name} logo`}/>}
        </LogoRoot> {pub.name}
      </PubAvatarRoot>
    );
  }

  return (
    <FormControl sx={{ m: 1, minHeight: 42, minWidth: 220 }} size="small">
      <Select
        margin={'dense'}
        displayEmpty
        onChange={(e: SelectChangeEvent) => {
          e.preventDefault();
          setSelectedOrganisation(e.target.value);
        }}
        defaultValue={selectedOrganisation as string}
        renderValue={value => {
          return (
            <RootText>
              {organisation?.logo_filename && <img width="24"
                                                   src={`${getAssetsBaseUrl()}/logo/${organisation.logo_filename}`}
                                                   alt={`${organisation?.name} logo`}/>}
              {!organisation?.logo_filename &&
                <img width="24" src={`https://assets.pixels.ai/logo/unknown-logo.png`}
                     alt={`${organisation?.name} logo`}/>}
              {organisation.name}
            </RootText>
          );
        }}
      >
        {organisations.map(({ logo_filename, domain, name }, index) => {
          return (
            <MenuItem key={index} value={domain}>
              <ListItemIcon>
                <LogoRoot>
                  {logo_filename && <img width="24"
                                               src={`${getAssetsBaseUrl()}/logo/${logo_filename}`}
                                               alt={`${organisation?.name} logo`}/>}
          {!logo_filename &&
            <img width="24" src={`https://assets.pixels.ai/logo/unknown-logo.png`}
                 alt={`${organisation?.name} logo`}/>}
                </LogoRoot>
                &nbsp; {name}
              </ListItemIcon>
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};
